// USER useSwrSearchPackActivatePackage ***************************************************************************
// pathname: /v1/search-pack/activate-package
// ************************************************************************************************
import { useTranslation } from 'next-i18next';
import { useSwrMutationApi } from '@hooks/useSwrApi';
import { ApiRequestBody } from '@type/api/apiUtilityFn';

/** Hook props */
type UseSwrActivatePackageReqBody = ApiRequestBody<'/v1/search-pack/activate-package', 'post'>;

interface UseSwrSearchPackActivatePackageProps {
  locale?: Locale;
  onSuccess?: () => void | Promise<void>;
  onError?: (err: unknown) => void;
}

/**
 * @description Hook for activating a search pack package.
 * - `locale`: The current app locale.
 * - `onSuccess`: Optional callback to execute on success.
 * - `onError`: Optional callback to execute on error.
 */
export const useSwrSearchPackActivatePackage = (props?: UseSwrSearchPackActivatePackageProps) => {
  const { onSuccess, onError } = props ?? {};
  const { t, i18n } = useTranslation('common');

  // SWR, activate the package
  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<undefined, UseSwrActivatePackageReqBody>({
    url: '/v1/search-pack/activate-package',
    locale: i18n.language,
    fetcherConfig: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: () => { if (onSuccess) { void onSuccess(); } },
      onError: (err) => { if (onError) onError(err); },
    },
    toastsOptions: {
      showSuccessToast: true,
      successToastText: t('flash.message.deal.success'),
      showErrorToast: true,
    },
  });

  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};

